import { Box, HStack, VStack } from "@chakra-ui/react";
import { colors } from "goi_common";

interface ExpectedPriceRangeBarProps {
  min: number;
  max: number;
  MIN_PRICE: number;
  MAX_PRICE: number;
  /** sticky/full-bleed 상황에서 컨테이너 카드 느낌 제거: borderRadius 0. */
  fullBleed?: boolean;
  /**
   * 막대 위 제목. 표시 값이 해당 업체 가격이 아닐 때(장지 견적의 공설/사설 전국 범위 등)
   * 정체를 밝히는 용도. 기본값이 기존 문구라 미지정 호출부는 동작이 바뀌지 않는다.
   */
  label?: string;
  /** 막대 아래 근거·주의 문구. 표본 수처럼 출처를 밝힐 때 쓴다. */
  note?: string;
}

export const ExpectedPriceRangeBar = ({
  min,
  max,
  MIN_PRICE,
  MAX_PRICE,
  fullBleed = false,
  label = "예상 비용 범위",
  note = "실제 비용은 상황에 따라 달라질 수 있습니다.",
}: ExpectedPriceRangeBarProps) => {
  const getBarPosition = (price: number): number => {
    if (MAX_PRICE === MIN_PRICE) {
      return 0;
    }
    return ((price - MIN_PRICE) / (MAX_PRICE - MIN_PRICE)) * 100;
  };

  return (
    <VStack width="100%" spacing="24px" alignItems="stretch">
      <Box borderRadius={fullBleed ? "0" : "12px"} bg={colors.gray50} px="24px" pb="14px" pt="40px">
        <VStack spacing="16px" alignItems="stretch">
          <VStack width="100%" spacing="12px">
            <Box position="relative" width="100%" height="8px">
              <Box width="100%" height="100%" bg={colors.gray200} borderRadius="full" />

              <Box
                position="absolute"
                top="0"
                height="100%"
                bg={colors.orange650}
                transition="all 0.5s ease"
                left={`${getBarPosition(min)}%`}
                width={`${getBarPosition(max) - getBarPosition(min)}%`}
              >
                <div
                  className="caption_12_sb orange650"
                  css={{
                    position: "absolute",
                    top: "-24px",
                    left: "50%",
                    transform: "translateX(-50%)",
                    whiteSpace: "nowrap",
                    transition: "all 0.5s ease",
                  }}
                >
                  {label}
                </div>
                <Box
                  position="absolute"
                  left="0px"
                  top="50%"
                  transform="translateY(-50%)"
                  width="2px"
                  height="16px"
                  bg={colors.orange650}
                />
                <Box
                  position="absolute"
                  right="0px"
                  top="50%"
                  transform="translateY(-50%)"
                  width="2px"
                  height="16px"
                  bg={colors.orange650}
                />
              </Box>
            </Box>

            <HStack width="100%" justifyContent="space-between" color={colors.gray400}>
              <div className="caption_12_m gray600">{MIN_PRICE.toLocaleString()}만원</div>
              <div className="caption_12_m gray600">{MAX_PRICE.toLocaleString()}만원</div>
            </HStack>
            <div className="caption_12_m gray600">{note}</div>
          </VStack>
        </VStack>
      </Box>
    </VStack>
  );
};
